import { useState } from "react";
import { newReleaseTabs } from "@/mocks/manga";

export default function NewReleaseSection() {
  const [activeKey, setActiveKey] = useState(newReleaseTabs[0].key);
  const active = newReleaseTabs.find((tab) => tab.key === activeKey) ?? newReleaseTabs[0];

  return (
    <section id="new" className="w-full bg-background-100 py-16 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="max-w-2xl">
          <span className="inline-flex items-center gap-1.5 text-xs font-label text-accent-700 uppercase tracking-widest">
            <i className="ri-flashlight-line text-base" aria-hidden="true"></i>
            New Releases
          </span>
          <h2 className="mt-2 font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            分类新番：最近值得一试的新作品
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">
            人气榜回答「大家在看什么」，分类新番回答「最近有什么新东西」。
            下面按题材分档，点开任意一栏，就能看到该方向新开更或近期上新的作品。
          </p>
        </div>

        <div
          role="tablist"
          aria-label="分类新番题材"
          className="mt-8 flex flex-wrap gap-2 p-1 rounded-full bg-background-50 border border-background-200 w-fit max-w-full"
        >
          {newReleaseTabs.map((tab) => (
            <button
              key={tab.key}
              type="button"
              role="tab"
              aria-selected={activeKey === tab.key}
              onClick={() => setActiveKey(tab.key)}
              className={`px-4 py-2 rounded-full text-sm font-label transition-colors whitespace-nowrap cursor-pointer ${
                activeKey === tab.key
                  ? "bg-accent-500 text-background-50"
                  : "text-foreground-700 hover:text-accent-700"
              }`}
            >
              {tab.label}
            </button>
          ))}
        </div>

        <p key={active.key} className="mt-6 text-sm text-foreground-600 leading-relaxed max-w-3xl animate-fade-up">
          {active.intro}
        </p>

        <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {active.items.map((item) => (
            <article
              key={item.title}
              className="flex gap-4 p-4 rounded-lg bg-background-50 border border-background-200 hover:border-accent-300 transition-colors"
            >
              <div className="w-24 h-32 md:w-28 md:h-36 shrink-0 rounded-md overflow-hidden bg-background-200">
                <img
                  src={item.cover}
                  alt={`${item.title} 漫画封面`}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="font-heading text-base font-bold text-foreground-950">
                  {item.title}
                </h3>
                <p className="mt-1 text-xs font-label text-foreground-500">
                  {item.author} · {item.chapter}
                </p>
                <p className="mt-1 text-xs font-label text-secondary-700">
                  {item.frequency}
                </p>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed line-clamp-3">
                  {item.desc}
                </p>
                <div className="mt-2.5 flex flex-wrap gap-1.5">
                  {item.tags.map((tag) => (
                    <span
                      key={tag}
                      className="px-2 py-0.5 rounded-md bg-accent-50 text-accent-800 text-xs font-label"
                    >
                      #{tag}
                    </span>
                  ))}
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}